import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AnswersProvider } from "./context/AnswersContext";
import { DataProvider } from "./context/DataContext";
import { EmailTypeProvider } from "./context/EmailTypeContext";
import { GlobalStylesProvider } from "./context/GlobalStylesContext";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GlobalStylesProvider>
    <EmailTypeProvider>
      <AnswersProvider>
        <DataProvider>
          <App />
        </DataProvider>
      </AnswersProvider>
    </EmailTypeProvider>
  </GlobalStylesProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
